import UltMeta, { Meta } from "./UltMeta/index";

class PurchaseGoodsState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    SIGNING = new Meta(2, "签署中");
    FINISHED = new Meta(3, "已完成", "color-info");
    INVALIDING = new Meta(4, "作废中");
    INVALID = new Meta(5, "已作废");
}

export const PURCHASE_GOODS_STATE = new PurchaseGoodsState();

class DownStreamPurchaseGoodsState extends UltMeta {
    ALL = new Meta(0, "全部"); //后端不接, 需删除
    FINISHED = new Meta(3, "已完成");
    INVALIDING = new Meta(4, "作废中");
    INVALID = new Meta(5, "已作废");
}

export const DOWN_STREAM_PURCHASE_GOODS_STATE = new DownStreamPurchaseGoodsState();

class PurchaseGoodsType extends UltMeta {
    ONE = new Meta(1, "作为提货单位");
    TWO = new Meta(2, "作为供货单位");
}

export const PURCHASE_GOODS_TYPE = new PurchaseGoodsType();

class ReceiptType extends UltMeta {
    UNSIGNED = new Meta(1, "未签收", "#FFBE17");
    SIGNING = new Meta(2, "签收中", "#FFBE17");
    FINISHED = new Meta(3, "已签收", "#999999");
}

export const RECEIPT_TYPE = new ReceiptType();

/**运输类型 */
class TransportType extends UltMeta {
    SHIPPING = new Meta(1, "船运");
    AUTOMOBILE_TRANSPORT = new Meta(2, "汽运");
}

export const TRANSPORT_TYPE = new TransportType();
